import React, { useState, useEffect } from "react";
import { StyleSheet, View, Dimensions, ScrollView } from "react-native";

import Utils, {
  hasItems,
  getActivitiesWithTags,
  escapeRegexp,
  sortByRelevance,
} from "../../../../helpers/utils";

import AppConfig from "../../../../config/AppConfig";
import SwipeablePanel from "../../common/SwipeablePanel/index";
import Search from "../../common/search-bar/Search";
import CopyActivitiesList from "./CopyActivitiesList";
import BottomButton from "../../common/BottomButton";
import Dialog from "../../common/dialog";
import appStyles from "../../../appStyles";

const { height: HEIGHT, width: WIDTH } = Dimensions.get("window");

export default function CopyTagsFromActivitiesPanel({
  controller,
  selectedTagIds = [],
  saveCopyTags = () => {},
  toggleCopyTagsPanel = () => {},
}) {
  const [activities, setActivities] = useState([]);
  const [favoriteActivities, setFavoriteActivities] = useState([]);
  const [tags, setTags] = useState([]);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [buttonText, setButtonText] = useState("Add Tags to Activity");
  const [selectedActivities, setSelectedActivities] = useState({});

  const [showDialog, setShowDialog] = useState(false);
  const [showCopyTagsPanel, setShowCopyTagsPanel] = useState(false);

  useEffect(() => {
    filterResults({});
  }, [selectedTagIds.length]);

  useEffect(() => {
    setShowSaveButton(hasItems(tags));
    setButtonText(`Add ${tags.length} Tags to Activity`);
  }, [tags]);

  const filterResults = ({
    term,
    showActivities = true,
    showTags = true,
    showFavorites = true,
    showArchived = false,
    sets = [],
  }) => {
    let filteredActivities = showActivities
      ? getActivitiesWithTags(controller.state, selectedTagIds)
      : [];

    if (!showArchived)
      filteredActivities = filteredActivities.filter((a) => a.is_active);
    if (!showFavorites)
      filteredActivities = filteredActivities.filter((a) => a.is_favorite != 1);

    // Multi terms search
    if (term) {
      const pattern = Utils.getSearchPattern(term);
      filteredActivities = filteredActivities.filter((a) => {
        return a.name && a.name.match(pattern);
      });
    }

    const favoriteActivities = filteredActivities.filter(
      (a) => a.is_favorite == 1,
    );

    setActivities(sortByRelevance(filteredActivities, term));
    setFavoriteActivities(sortByRelevance(favoriteActivities, term));
  };

  // Close activities list from which user can copy tags
  const closeCopyTagsPanel = () => {
    // if tags were selected show discard dialog
    if (hasItems(tags)) {
      setShowDialog(true);
    } else {
      toggleCopyTagsPanel();
    }
  };

  const discardTags = () => {
    setTags([]);
    setSelectedActivities({});
    setShowDialog(false);
    toggleCopyTagsPanel();
  };

  const selectActivityTags = (item, isSelected) => {
    selectedActivities[item.id] = isSelected ? item.tags || [] : [];

    const allSelectedTags = new Set();
    for (let key in selectedActivities) {
      selectedActivities[key].forEach((t) => {
        if (!selectedTagIds.includes(t)) {
          allSelectedTags.add(t);
        }
      });
    }

    setTags([...allSelectedTags]);
  };

  const saveTags = () => {
    saveCopyTags(tags);
    setSelectedActivities({});
  };

  onSelectTag = (tag) => {
    /* tag.isSelected = !tag.isSelected;

    const allSelectedTags = new Set(tags);
    if (tag.isSelected) {
      allSelectedTags.add(tag.id);
    } else {
      allSelectedTags.delete(tag.id);
    }

    setTags([...allSelectedTags]); */
  };

  return (
    <View style={styles.container}>
      {showDialog ? (
        <Dialog.Container onClose={() => setShowDialog(false)}>
          <Dialog.Title>Discard New Tags?</Dialog.Title>
          <Dialog.Description>
            Are you sure you want to close without adding tags from selected
            activities?
          </Dialog.Description>
          <Dialog.Button label="Discard" onPress={discardTags} />
          <Dialog.Button label="Back" onPress={() => setShowDialog(false)} />
        </Dialog.Container>
      ) : null}

      <SwipeablePanel
        fullWidth
        openLarge
        showCloseButton
        closeOnTouchOutside
        noBar
        panelColor="#FFF"
        onClose={closeCopyTagsPanel}
        isActive={true}
      >
        <ScrollView style={styles.scrollView}>
          {hasItems(favoriteActivities) ? (
            <CopyActivitiesList
              title="Favorites"
              activities={favoriteActivities}
              selectActivityTags={selectActivityTags}
              contentType="Favorites"
              initialNumToRender={AppConfig.NUM_OF_FAVORITES}
              onSelectTag={onSelectTag}
            />
          ) : null}

          {hasItems(activities) ? (
            <CopyActivitiesList
              title="All activities"
              contentType="activities"
              activities={activities}
              selectActivityTags={selectActivityTags}
              initialNumToRender={AppConfig.NUM_OF_ACTIVITIES}
              onSelectTag={onSelectTag}
            />
          ) : null}
        </ScrollView>

        <View style={appStyles.footerOptions}>
          <Search
            filterResults={filterResults}
            placeholder="Search Activities"
            controller={controller}
          />

          {showSaveButton ? (
            <BottomButton buttonText={buttonText} onPress={saveTags} />
          ) : null}
        </View>
      </SwipeablePanel>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    bottom: 0,
    left: 0,
    height: HEIGHT,
    width: WIDTH,
    zIndex: 200,
    elevation: 3,
    ...appStyles.maxWidth,
  },
  scrollView: {
    height: HEIGHT - 170,
    paddingBottom: 130,
    backgroundColor: "#FFF",
  },
});
